import {CommonAlertService} from './../../services/common-alert.service';
import {filter} from 'rxjs/operators';
import {MasterService} from './../../home/services/master.service';
import {Component, OnInit, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {NgForm, Form} from '@angular/forms';

@Component({
  selector: 'app-antennas-modal',
  templateUrl: './antennas-modal.component.html',
  styleUrls: ['./antennas-modal.component.scss']
})
export class AntennasModalComponent implements OnInit {
  editOb: any;
  editData: any;
  nameID: any;
  successMsg: any;
  public user = {
    name: '',
  }
  public editPermission = false;
  // tslint:disable-next-line:max-line-length
  constructor(public dialogRef: MatDialogRef<AntennasModalComponent>, public masterService: MasterService, @Inject(MAT_DIALOG_DATA) data, public commonAlertService: CommonAlertService) {

    if (data) {
      this.editOb = data.edit;
    }
  }


  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.editPermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals
      if (roles['more.antennas.edit'] == 1) {
        this.editPermission = true;
      }
    }
    if (this.editOb) {
      this.masterService.getRecordById(this.editOb.editID, this.editOb.encryId, '/antennas/get_data').subscribe(res => {
        // @ts-ignore
        this.editData = res.data;
      });
    }

  }

  close() {
    this.dialogRef.close();
  }
  submitForm(data) {
    if (this.editData) {
      // tslint:disable-next-line:max-line-length variable-name no-shadowed-variable
      const form_data = Object.assign(data, { id: this.editOb.editID }, { enc_id: this.editOb.encryId }, { token: localStorage.getItem('token')});
      this.successMsg = 'Record Updated Successfully';
      this.masterService.addEditRecord(form_data, '/antennas/update').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showEdit({message: this.successMsg});
        }
      });

    } else {
      // tslint:disable-next-line:variable-name
      const form_data = Object.assign(data, { token: localStorage.getItem('token')});
      this.successMsg = 'Record Added Successfully';
      this.masterService.addEditRecord(form_data, '/antennas/store').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showSuccessMsg({message: this.successMsg});
        }
      });
    }
    this.close();
  }
}
